import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {
  Breadcrumb,
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Spinner,
} from 'react-bootstrap'
import {useDisclourse} from '../../hooks/useDisclourse'
import {Tooltip} from 'react-tooltip'
//import {AsideMenuSignatureForms} from './components/AsideMenuSignatureForms'
import {useLazyQuery, useQuery} from '@apollo/client'
import {GET_ALL_SIGNATURE_FORMS_ENTRIES_API} from '../../gql/queries/signatureFormsEntriesApiQueries'
import {GET_ONE_SIGNATURE_FORM_API} from '../../gql/queries/signatureFormsApiQueries'
import {IResAllListUsers, IResAllUsers} from '../../types/users'
import {GET_ALL_USERS_LIST} from '../../gql/queries/usersQuery'
import {toast} from 'react-toastify'
import {
  IResSignatureFormsEntriesAPI,
  NodeSignatureFormsEntry,
} from '../../types/signatureFormsEntriesApi'
import {parseId} from '../../helpers'
import moment from 'moment'
import {ModalPreview} from './components/ModalPreview'
import {BadgeStatus} from './components/BadgeStatus'
import {SIZE_PAGE_DEFAULT} from '../../helpers/consts'
import {PaginationUtils} from '../shared/PaginationUtils'
import icons from '../../../../_metronic/helpers/icons-config/icons'
import {PaginationSection} from '../shared/PaginationSection'
import {AgentInfoTooltip} from '../shared/AgentInfoTooltip'
import {UserAvatar} from '../../components/UserAvatar'

export const SignatureFormsEntriesPage = () => {
  const {id} = useParams<{id: string}>()
  const navigate = useNavigate()

  const [
    gqlGetSignatureFormsEntries,
    {data: dataAllSignatureFormsEntries, loading, error, refetch: refetchEntries},
  ] = useLazyQuery<IResSignatureFormsEntriesAPI>(GET_ALL_SIGNATURE_FORMS_ENTRIES_API, {
    fetchPolicy: 'no-cache',
  })

  const [getOneSignatureForm, {data: dataOneSignatureForm}] = useLazyQuery(
    GET_ONE_SIGNATURE_FORM_API
  )
  const [formName, setFormName] = useState<string | null>(null)
  useEffect(() => {
    const decodedId = id ? fromGlobalId(id) : null
    if (decodedId) {
      getOneSignatureForm({
        variables: {id: decodedId},
      })
    }
  }, [id, getOneSignatureForm])

  useEffect(() => {
    if (dataOneSignatureForm?.signatureFormById?.name) {
      setFormName(dataOneSignatureForm.signatureFormById.name)
    }
  }, [dataOneSignatureForm])

  const {data: dataMembers, error: errorMembers} = useQuery<IResAllListUsers>(GET_ALL_USERS_LIST, {
    fetchPolicy: 'no-cache',
  })
  const [valueUser, setValueUser] = useState('')

  const {isOpen: isOpenPreview, onClose: onClosePreview, onOpen: onOpenPreview} = useDisclourse()

  const [tabFilters, setTabFilters] = useState('SignatureFormsEntries')

  const [infoPreview, setInfoPreview] = useState<null | NodeSignatureFormsEntry>(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [offset, setOffset] = useState(0)
  const [first, setFirst] = useState(SIZE_PAGE_DEFAULT)

  const [isPag, setIsPag] = useState(false)
  const [page, setPage] = useState(1)

  const [dataArr, setDataArr] = useState<
    IResSignatureFormsEntriesAPI['allSignatureFormsEntries']['edges']
  >([])

  let totalSignatureFormsEntries =
    dataAllSignatureFormsEntries?.allSignatureFormsEntries?.totalCount ?? 0

  const totalPages = Math.ceil(totalSignatureFormsEntries / first)
  const {start, end} = PaginationUtils.getPaginationRange(
    currentPage,
    first,
    totalSignatureFormsEntries
  )

  const initialFormData = {
    recipient: '',
    status: '', // 'PENDING' | 'SIGNED'
    user: '', // ID del usuario creador
  }

  const [formData, setFormData] = useState(initialFormData)

  const handleFilters = () => {
    const signatureFormId = id ? fromGlobalId(id) : null
    const userId = valueUser ? fromGlobalId(valueUser) : null

    const variables = {
      first: first,
      offset: (currentPage - 1) * first,
      recipient: formData.recipient || null,
      status: filterStatus === 'all' ? null : filterStatus,
      user: userId, // Si se está filtrando por un usuario específico
      signatureForm: signatureFormId, // Si se está filtrando por un formulario específico
    }
    gqlGetSignatureFormsEntries({
      variables,
    })
  }

  type IFilterStatus = 'all' | 'SIGNED' | 'PENDING'
  const [filterStatus, setFilterStatus] = useState<IFilterStatus>('all')

  useEffect(() => {
    handleFilters()
    setSignatureFormsEntriesSelected([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [first, gqlGetSignatureFormsEntries, currentPage, tabFilters])

  const [signatureFormsEntriesSelected, setSignatureFormsEntriesSelected] = useState<
    {id: string; recipient: string; status: string; user: string}[] | undefined
  >([])

  const isAllSelected =
    signatureFormsEntriesSelected?.length ===
    dataAllSignatureFormsEntries?.allSignatureFormsEntries?.edges?.length

  const toggleAll = () => {
    if (isAllSelected) {
      setSignatureFormsEntriesSelected([])
    } else {
      if (dataAllSignatureFormsEntries?.allSignatureFormsEntries?.edges?.length) {
        const allIds = dataAllSignatureFormsEntries.allSignatureFormsEntries.edges.map((edge) => ({
          id: edge.node.id,
          recipient: edge.node.recipient,
          status: edge.node.status,
          user: edge.node.user
            ? edge.node.user?.firstName ?? ' ' + edge.node.user?.lastName ?? ''
            : '',
        }))
        setSignatureFormsEntriesSelected(allIds)
      }
    }
  }

  const toggleOne = (id: string) => {
    if (!id || !signatureFormsEntriesSelected) return

    const exists = signatureFormsEntriesSelected.find((x) => x.id === id)

    if (exists) {
      setSignatureFormsEntriesSelected(signatureFormsEntriesSelected.filter((x) => x.id !== id))
    } else {
      const found = dataAllSignatureFormsEntries?.allSignatureFormsEntries?.edges.find(
        (e) => e.node?.id === id
      )

      if (found?.node) {
        setSignatureFormsEntriesSelected([
          ...signatureFormsEntriesSelected,
          {
            id: found.node.id,
            recipient: found.node.recipient,
            status: found.node.status ?? '',
            user: found.node.user
              ? found.node.user?.firstName ?? ' ' + found.node.user?.lastName ?? ''
              : '',
          },
        ])
      }
    }
  }

  const handleRecipientName = () => {
    handleFilters()
  }

  useEffect(() => {
    if (!dataAllSignatureFormsEntries) return
    const {edges} = dataAllSignatureFormsEntries.allSignatureFormsEntries
    // if (edges.length === 0) return
    if (isPag) {
      setDataArr((p) => [...p, ...edges])
    } else {
      setDataArr(edges)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAllSignatureFormsEntries])

  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error.message}`)
    }
  }, [error])

  const updatePage = (n: number) => {
    setCurrentPage(n)
  }

  // if ((loading || !dataAllSignatureForms) && !isPag) {
  //   return <LoadingSignatureForms />
  // }

  return (
    <div className='signatureForms-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='fs-3' onClick={(e) => navigate('/signature-forms')}>
            Signature Forms List
          </Breadcrumb.Item>
          <Breadcrumb.Item className='fs-3'>
            {formName ? `${formName} > Entries` : ' Entries List'}
          </Breadcrumb.Item>
        </Breadcrumb>
      </header>
      <Row className='signatureForms'>
        <Col className='container'>
          <div className='signatureForms-container'>
            <div className='title-header'>
              <h3>All Signature Forms Entries</h3>
            </div>
            <div className='filters-header'>
              <InputGroup>
                <Form.Control
                  placeholder='Filter by recipient name'
                  aria-label="Recipient's name with two button addons"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      recipient: e.target.value,
                    }))
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleRecipientName()
                    }
                  }}
                  value={formData.recipient}
                  disabled={false}
                />
                <Form.Select
                  value={filterStatus}
                  aria-label='Filter by status'
                  onChange={(e) => setFilterStatus(e.target.value as IFilterStatus)}
                >
                  <option value='all'>Filter by Status</option>
                  <option value='SIGNED'>Signed</option>
                  <option value='PENDING'>Pending</option>
                </Form.Select>
                <Form.Select
                  aria-label='Filter by user'
                  name='userFilter'
                  value={valueUser}
                  onChange={(e) => {
                    const {value} = e.target
                    setValueUser(value)
                  }}
                >
                  <option value=''>Filter by user</option>
                  {dataMembers?.allUsersList.map((node) => (
                    <option key={node.id} value={node.id}>
                      {node.firstName + ' ' + node.lastName}
                    </option>
                  ))}
                </Form.Select>
                <Button
                  disabled={false}
                  onClick={() => handleFilters()}
                  variant='outline-success'
                  style={{border: '1px solid #dbdfe9'}}
                >
                  Search
                </Button>
                <Button
                  disabled={false}
                  variant='outline-primary'
                  style={{border: '1px solid #dbdfe9'}}
                >
                  Filter
                </Button>
              </InputGroup>
            </div>
            <div className='results-header'>
              <PaginationSection
                first={first}
                setFirst={(n) => {
                  setFirst(n)
                  setPage(1)
                  setOffset(0)
                }}
                currentPage={currentPage}
                totalPages={totalPages}
                start={start}
                end={end}
                totalPolicies={totalSignatureFormsEntries}
                updatePage={updatePage}
                PaginationUtils={PaginationUtils}
              />
              <div className='col-md-3'>
                <div className='results-filter'>
                  <Col lg={12} md={12} sm={12} xs={12}></Col>
                </div>
              </div>
            </div>

            <div className='table-responsive'>
              <table
                className='table table-striped table-hover align-middle'
                style={{tableLayout: 'fixed', width: '100%'}}
              >
                <colgroup>
                  <col style={{width: '12%'}} />
                  <col style={{width: '18%'}} />
                  <col style={{width: '14%'}} />
                  <col style={{width: '16%'}} />
                  <col style={{width: '16%'}} />
                  <col style={{width: '10%'}} />
                  <col style={{width: '18%'}} />
                  <col style={{width: '12%'}} />
                </colgroup>
                <thead>
                  <tr role='row'>
                    <th className='fw-bold'>Agent</th>
                    <th className='fw-bold'>Recipient</th>
                    <th className='fw-bold'>Status</th>
                    <th className='fw-bold'>Requested on</th>
                    <th className='fw-bold'>Signed on</th>
                    <th className='fw-bold'>Signed from</th>
                    <th className='fw-bold'>Form name</th>
                    <th className='fw-bold'>Actions</th>
                  </tr>
                </thead>
                {(loading || !dataAllSignatureFormsEntries) && !isPag ? (
                  <tbody>
                    <tr>
                      <td colSpan={8}>
                        <div className='d-flex flex-center' style={{height: '30vh'}}>
                          <Spinner animation='border' />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {dataArr.length === 0 && (
                      <tr>
                        <td colSpan={8}>
                          <div className='d-flex flex-center' style={{height: '30vh'}}>
                            There are no signature Forms entries currently added
                          </div>
                        </td>
                      </tr>
                    )}
                    {loading && (
                      <tr>
                        <td colSpan={8}>
                          <div className='d-flex flex-center' style={{height: '30vh'}}>
                            <Spinner animation='border' />
                          </div>
                        </td>
                      </tr>
                    )}
                    {dataArr.slice(first * page - first, first * page).map(({node}) => (
                      <tr key={node.id}>
                        <td className='text-center'>
                          <UserAvatar user={node.agent ?? null} tooltipId={`myt${node.id}`} size={40} />
                          <AgentInfoTooltip id={`myt${node.id}`} user={node.agent ?? null} />
                        </td>
                        <td className='text-break'>
                          <div>
                            <span
                              className='text-primary'
                              style={{cursor: 'pointer'}}
                              data-tooltip-id={`myt2${parseId(node.id)}`}
                            >
                              {node.recipient}
                            </span>
                          </div>
                        </td>
                        <td className='text-break'>
                          <div>
                            <BadgeStatus state={node.status} />
                          </div>
                        </td>
                        {/* <td>
                        
                      </td> */}
                        <td className='text-break'>
                          <div>
                            {node.requestedOn ? (
                              <>
                                {moment(node.requestedOn).format('MMM DD, YYYY')}
                                <br />
                                <span style={{fontSize: 13, color: '#888'}}>
                                  {moment(node.requestedOn).format('hh:mm a')}
                                </span>
                              </>
                            ) : (
                              '-'
                            )}
                          </div>
                        </td>
                        <td className='text-break'>
                          <div>
                            {node.signedOn ? (
                              <>
                                {moment(node.signedOn).format('MMM DD, YYYY')}
                                <br />
                                <span style={{fontSize: 13, color: '#888'}}>
                                  {moment(node.signedOn).format('hh:mm a')}
                                </span>
                              </>
                            ) : (
                              '-'
                            )}
                          </div>
                        </td>
                        <td className='text-break'>-</td>
                        <td className='text-break'>{node.signatureForm?.name || '-'}</td>
                        <td className='text-center text-md-end'>
                          <Dropdown as={ButtonGroup}>
                            <Button
                              variant='outline-primary'
                              size='sm'
                              style={{border: '1px solid #3e97ff'}}
                              onClick={() => {
                                onOpenPreview()
                                setInfoPreview(node)
                              }}
                            >
                              Preview
                            </Button>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </Col>
      </Row>

      {/*
      showAside && (
        <AsideMenuSignatureForms
          isOpen={showAside}
          onClose={() => setShowAside(false)}
          tabFilters={tabFilters}
          setTabFilters={setTabFilters}
        />
      )
      */}

      {isOpenPreview && infoPreview && (
        <ModalPreview
          info={infoPreview}
          isOpen={isOpenPreview}
          onClose={onClosePreview}
          refetch={refetchEntries}
        />
      )}
    </div>
  )
}

function fromGlobalId(globalId: string) {
  const decoded = atob(globalId)
  // decoded será algo como "signature_form_node:1"
  return decoded.split(':')[1]
}
